import React, { Component, Fragment } from 'react'
import { Button, Col, Container, Form, Row } from 'react-bootstrap'

import RestClient from '../../RestAPI/RestClient'
import AppUrl from '../../RestAPI/AppUrl';

export class VendorRegistration extends Component {
    
  
  vendor(){
           
   let name = document.getElementById("name").value;
     let businessname = document.getElementById("businessname").value;
      let phone = document.getElementById("phone").value;
       let businesstype = document.getElementById("businesstype").value;
         let businesslink = document.getElementById("businesslink").value;
             let email = document.getElementById("email").value;
           let message = document.getElementById("message").value;
            
     
        alert(name+'/'+businessname+'/'+businesstype+'/'+businesslink+'/'+email+'/'+phone+'/'+message);

          let jsonObject ={name:name,phone:phone,email:email,businessname:businessname,businesstype:businesstype,
            businesslink:businesslink,message:message }
      
      // alert(name+'/'+email+'/'+phone);

        //  let jsonObject ={name:name,phone:phone,email:email }
       
       RestClient.PostRequest(AppUrl.VendorReg,JSON.stringify(jsonObject)
      ).then(result=>{
        alert(result);
      }).catch(error=>{
        alert("Error");
      })
      
      



  }





  render() {
    return (
      <Fragment>
         <Container className='mt-5 mb-5'>
                    <Row>
                        <Col lg={6} md={6} sm={12}>
                        <h1>Vendor's Registrations</h1>
                        <Form>
              <Form.Group className="mb-3" >
                <Form.Label>Your Name</Form.Label>
                <Form.Control id="name" type="text" placeholder="Enter Your Full Name" />

                
               
              </Form.Group>

               <Form.Group className="mb-3" >
                <Form.Label>Business Name</Form.Label>
                <Form.Control id="businessname" type="text" placeholder="Enter Your Business Name" />
               
              </Form.Group>
                 <Form.Group className="mb-3" >
                <Form.Label>Phone</Form.Label>
                <Form.Control id="phone" type="text" placeholder="Enter your Phone Number" />
               
              </Form.Group>

               <Form.Group className="mb-3" >
                <Form.Label>Business Type</Form.Label>
                <Form.Control id="businesstype" type="text" placeholder="Like Clothing or Jewlerry" />
               
              </Form.Group>
               <Form.Group className="mb-3" >
                <Form.Label>Business URL Link</Form.Label>
                <Form.Control id="businesslink" type="text" placeholder="Enter Your website link" />
               
              </Form.Group>
        
             
        

        
                <Form.Group className="mb-3" >
                <Form.Label>Email address</Form.Label>
                <Form.Control required id='email' type="email" placeholder="Enter email" />
                <Form.Text className="text-muted">
                  We'll never share your email with anyone else.
                </Form.Text>
              </Form.Group>
                <Form.Group className="mb-3" >
                      <Form.Label> Vendor Space is '9x9' </Form.Label> <br />
                      <Form.Text className="text-muted">
                  Once your application has been reviewed and if you are accepted as a vendor, you will receive a contact and payment details.
                </Form.Text>
                    
                    </Form.Group>

                <Form.Group className="mb-3" >
                      <Form.Label>Message</Form.Label>
                      <Form.Control id='message' as="textarea" rows={3} placeholder="Share your thoughts" />
                      
                    </Form.Group>
        
              
             
              <Button onClick={this.vendor} variant="primary" >
                Submit
              </Button>
            </Form>
        
        
                        </Col>
                        
                    </Row>
                </Container>

      </Fragment>
    )
  }
}

export default VendorRegistration
